<form [formGroup]="skjema" data-testid="skjema">
  <div cdkDropList (cdkDropListDropped)="radFlyttet($event)" [cdkDropListSortPredicate]="flyttingTillatFn()">
    @for (kontroller of skjema.controls; track indeks; let indeks = $index; let erSisteRad = $last) {
      <div class="tema-rediger-rad" [class]="{slettet: kontroller.value.slettet, arkivert: kontroller.value.arkivert}" cdkDrag [cdkDragDisabled]="erSisteRad" data-testid="rad">
        @if(kontroller.value.erArvet){
          <div class="arvet">{{ 'Arvet fra gruppemal'|translate }}</div>
        }
        <div class="kontainer">
          <div cdkDragHandle class="sortering-handler" [class.skjult]="erSisteRad">
            <mat-icon fontSet="ion-navicon" class="mat-icon--ionic-ikon" data-testid="dra-og-slipp"/>
          </div>

          <div class="tema-felt-gruppe">
            <mat-form-field class="tittel">
              <mat-label>
                @if (kontroller.value.ny) {
                  {{ 'Nytt tema' | translate }}
                } @else {
                  {{ 'Navn' | translate }}
                }
              </mat-label>
              <input matInput [formControl]="kontroller.controls.tittel" name="tittel" data-testid="navn-felt">
              @if (kontroller.controls.tittel.hasError('duplikat')) {
                <mat-error data-testid="navn-feilmelding">{{ 'Temanavn må være unikt' | translate }}</mat-error>
              }
              @if (kontroller.controls.tittel.hasError('maxlength')) {
                <mat-error data-testid="navn-feilmelding">
                  {{ kontroller.controls.tittel.errors | standardvalideringsfeil:'maxlength' }}
                </mat-error>
              }
            </mat-form-field>

            @if (!erSisteRad) {
              <mat-form-field class="beskrivelse">
                <mat-label>{{ 'Beskrivelse' | translate }}</mat-label>
                <riktekst-redigering [skjemakontroll]="kontroller.controls.beskrivelse" data-testid="beskrivelse-felt"/>
              </mat-form-field>
            }
          </div>

          <div class="handling" [class.skjult]="erSisteRad">
            @if (kontroller.value.arkivert) {
              <button mat-stroked-button type="button"
                      (click)="reaktiver(kontroller)"
                      [matTooltip]="'Temaet er arkivert. Reaktiver den for å gjøre den tilgjengelig igjen.' | translate"
                      data-testid="reaktiver-knapp">
                {{ 'Reaktiver' | translate }}
              </button>
            } @else if (kontroller.value.slettet) {
              <button mat-stroked-button type="button" (click)="angreSlett(kontroller)" data-testid="angre-knapp">
                {{ 'Angre' | translate }}
              </button>
            } @else if (kontroller.value.kanIkkeSlettes) {
              <button mat-stroked-button type="button"
                      (click)="arkiver(kontroller)"
                      [matTooltip]="'Temaet er i bruk og kan ikke slettes, kun arkiveres.' | translate"
                      data-testid="arkiver-knapp">
                {{ 'Arkiver' | translate }}
              </button>
            } @else {
              <button mat-icon-button type="button" (click)="slett(kontroller, indeks)" aria-label="Slett tema" data-testid="slett-knapp">
                <mat-icon fontSet="ion-ios-trash-outline" class="mat-icon--ionic-ikon"/>
              </button>
            }
          </div>
        </div>
      </div>
    }
  </div>

  <kort-handlinger>
    <button mat-button type="button" (click)="avbryt()" data-testid="avbryt-knapp">{{ 'Avbryt' | translate }}</button>
    <button mat-raised-button color="primary" type="submit" (click)="lagre()" [disabled]="lagrer() || skjema.invalid" data-testid="lagre-knapp">
      {{ 'Lagre' | translate }}
    </button>
  </kort-handlinger>
</form>
